import React, { useEffect, useRef } from "react";
import "../../styles/Home-module.css";
import { linkPath, linkPathIDCard } from "../../share/helper";
import { QRCode, Card, Avatar } from "antd";

import { BiGroup, BiHeading, BiHandicap } from "react-icons/bi";
import { IoCardOutline } from "react-icons/io5";
import { getCurrentUser } from "../../share/getProfile";

export default class CardComponentFront extends React.Component {
  render() {
    const {
      frontname,
      staffname,
      deparment,
      position,
      image,
      idnumber,
      frontImage,
      impage_profile,
      logoName,
      staffname_eng,
      qrcode_intergrate_id,
    } = this.props;

    const getProfileOrg = getCurrentUser();
    const cleaned_orgname = getProfileOrg.org_name_kh
      .replace(getProfileOrg.province_name, "")
      .trim();

    return (
      <div style={{ paddingTop: 80, width: "50%" }}>
        <div>
          <Card>
            <Avatar
              className="image-profile"
              src={linkPath + impage_profile}
              alt="profile"
            />

            <div className="text-overlaycard-container">
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  padding: 5,
                }}
              >
                <QRCode
                  errorLevel="H"
                  size={80}
                  color="#2471a3"
                  value={`https://card.votmean.app/${qrcode_intergrate_id}`}
                  icon={
                    "https://cdn-icons-png.flaticon.com/512/5290/5290070.png"
                  }
                  iconSize={30}
                />
                <p
                  style={{
                    color: "#2874a6",
                    fontSize: 10,
                    fontFamily: "Roboto",
                    transform: "scale(0.8)", // Shrink the text by 50%
                    display: "inline-block", // Prevent layout issues
                  }}
                >
                  ID:{idnumber}
                </p>
              </div>

              <div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    padding: 5,
                  }}
                >
                  <div
                  // style={{
                  //   backgroundColor: "#2874a6",
                  //   paddingTop: 2,
                  //   paddingBottom: 2,
                  //   paddingLeft: 10,
                  //   paddingRight: 10,
                  //   borderRadius: 20,
                  // }}
                  >
                    <span style={{ color: "#2874a6" }}>
                      {frontname} {staffname}
                    </span>
                  </div>
                  <span
                    style={{
                      color: "#2874a6",
                      fontFamily: "Roboto",
                      fontSize: "11px",
                    }}
                  >
                    {staffname_eng.toUpperCase() !== undefined
                      ? staffname_eng.toUpperCase()
                      : staffname_eng}
                  </span>
                  <span style={{ color: "#2874a6", fontSize: "11px" }}>
                    {position}
                  </span>
                  <div
                    style={{
                      flex: 1,
                      textAlign: "center",
                    }}
                  >
                    <span
                      style={{
                        fontFamily: 'Content',
                        fontWeight: 100,
                        fontSize: "10px",
                      }}
                    >
                      ប្រធាន{cleaned_orgname}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <img
              src={linkPathIDCard + frontImage}
              style={{ width: 285, height: 407, objectFit: "fit" }}
            />
          </Card>
        </div>
      </div>
    );
  }
}

// import React, { useMemo } from "react";
// import "../../styles/Home-module.css";
// import { linkPath, linkPathIDCard } from "../../share/helper";
// import { QRCode, Card, Avatar } from "antd";
// import { getCurrentUser } from "../../share/getProfile";
// import checkIcon from "../../assets/check.png";
// const CardComponentFront = ({
//   frontname,
//   staffname,
//   deparment,
//   position,
//   image,
//   idnumber,
//   frontImage,
//   impage_profile,
//   logoName,
//   staffname_eng,
// }) => {
//   const getProfileOrg = useMemo(() => getCurrentUser(), []);
//   const cleaned_orgname = useMemo(
//     () =>
//       getProfileOrg.org_name_kh.replace(getProfileOrg.province_name, "").trim(),
//     [getProfileOrg]
//   );

//   return (
//     <div style={{ paddingTop: 80, width: "50%" }}>
//       <Card>
//         <Avatar
//           className="image-profile"
//           src={linkPath + impage_profile}
//           alt="profile"
//         />

//         <div className="text-overlaycard-container">
//           <div style={{ display: "flex", flexDirection: "column", padding: 5 }}>
//             <QRCode
//               errorLevel="H"
//               size={80}
//               color="#2471a3"
//               value={`https://cards.devcomputing.pro/${idnumber}`}
//               icon={checkIcon}
//               iconSize={30}
//             />
//             <p style={{ color: "#2874a6", fontSize: 10, fontFamily: "Roboto" }}>
//               ID: {idnumber}
//             </p>
//           </div>

//           <div style={{ display: "flex", flexDirection: "column", padding: 5 }}>
//             <span style={{ color: "#2874a6" }}>
//               {frontname} {staffname}
//             </span>
//             <span
//               style={{
//                 color: "#2874a6",
//                 fontFamily: "Roboto",
//                 fontSize: "11px",
//               }}
//             >
//               {staffname_eng ? staffname_eng.toUpperCase() : ""}
//             </span>
//             <span style={{ color: "#2874a6", fontSize: "11px" }}>
//               {position}
//             </span>
//             <div style={{ flex: 1, textAlign: "center" }}>
//               <span
//                 style={{
//                   fontFamily: 'Content',
//                   fontWeight: 100,
//                   fontSize: "10px",
//                 }}
//               >
//                 ប្រធាន{cleaned_orgname}
//               </span>
//             </div>
//           </div>
//         </div>

//         <img
//           src={linkPathIDCard + frontImage}
//           style={{ width: 285, height: 407, objectFit: "fit" }}
//         />
//       </Card>
//     </div>
//   );
// };

// export default CardComponentFront;
